<template>
  <div class="section" id="profile-password-reset-completed">
    <div class="columns is-flex-direction-column">
      <div class="column">
        <h1 class="subtitle">パスワード変更</h1>
        <p class="block">パスワードの変更が完了しました。</p>
        <div class="formbutton">
          <router-link to="/mypage">
            <b-button type="is-primary"> マイページに戻る </b-button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfilePasswordResetCompleted'
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/profile-password-reset-completed.scss';
</style>
